import { isDynamicView } from './utils';

export const applyBuiltInRules = (entities = [], t) => {
  const dynamicViewTooltip = t('DYNAMIC_VIEW_TOOLTIP');

  return entities.map((entity) =>
    isDynamicView(entity)
      ? { ...entity, disabled: true, tooltipContent: dynamicViewTooltip }
      : entity,
  );
};
